import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import translations from './translations';

const PrepaidFormatter = ({ isPrepaid }) => (
  <FormattedMessage {...translations[isPrepaid ? 'inAdvance' : 'afterwards']} />
);

PrepaidFormatter.propTypes = {
  isPrepaid: PropTypes.bool,
};

PrepaidFormatter.defaultProps = {
  isPrepaid: true,
};

export default PrepaidFormatter;
